"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _grid = require("@rebass/grid");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledSystem = require("styled-system");
const _excluded = ["variant"]; // https://every-layout.dev/layouts/stack
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const properties = {
  default: 'marginTop',
  inline: 'marginLeft'
};
const Stack = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
      variant = 'default'
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return __jsx(StyledStack, (0, _extends2.default)({
    variant: variant
  }, props, {
    ref: ref
  }));
});
const getCss = (variant = 'default') => (0, _styledComponents.css)(["flex-direction:", ";&&{> * + *{", ";}}"], variant === 'default' ? 'column' : 'row', (0, _styledSystem.system)({
  spacing: {
    scale: 'space',
    property: properties[variant]
  }
}));
const StyledStack = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "Stack__StyledStack",
  componentId: "izate8-0"
})(["", ""], ({
  variant
}) => getCss(variant));
var _default = exports.default = Stack;